export const translations = {
  en: {
    // Meta Tags
    meta: {
      title: 'Prototype eSports - Competitive Battlefield Playes | Competitive Gaming Since 2012',
      description: 'Prototype eSports - Competitive Battlefield Playes. Dominating competitive esports since 2012 with strategic excellence, tactical mastery, and unbreakable teamwork. Join our legendary squad!',
      ogTitle: 'Prototype eSports - Competitive Battlefield Playes',
      ogDescription: 'Dominating competitive Battlefield esports since 2012. 15+ tournaments played, strategic excellence, and tactical mastery. Join our elite squad!',
      twitterTitle: 'Prototype eSports - Competitive Battlefield Playes',
      twitterDescription: 'Dominating competitive Battlefield esports since 2012. Join our elite squad!'
    },
    
    // Navigation
    nav: {
      home: 'Home',
      team: 'Team',
      tournaments: 'Tournaments',
      about: 'About',
      contact: 'Contact',
      joinSquad: 'Join Squad'
    },
    
    // Hero Section
    hero: {
      title: 'COMPETITIVE BATTLEFIELD TEAM',
      subtitle: 'Dominating the competitive Battlefield scene with precision, strategy, and unbreakable teamwork.',
      watchHighlights: 'Watch Highlights',
      joinTeam: 'Join Team'
    },

    clubInfo: {
        name: "Prototype eSports",
        tagline: "Dominating Battlefield",
        description: "Prototype eSports club dedicated to competitive excellence and strategic mastery. Join our ranks and experience the thrill of next-gen warfare.",
        founded: "2012",
        achievements: "15+",
        achievements_desc: "Tournaments Played",
        members: "20+",
        members_desc: "Active Members",
        winrate: "77.5%",
        winrate_desc: "Win Rate"
    },
    
    // Team Section
    team: {
      subtitle: 'Meet The Squad',
      title: 'PROTOTYPE eSPORTS TEAM',
      description: 'Our team consists of battle-hardened veterans who have dominated countless battlefields. Each member brings unique skills and tactical expertise to ensure victory.',
      stats: {
        battlefield: '6+',
        battlefield_desc: 'Battlefield Competing',
        achievements: "15+",
        achievements_desc: 'Tournament Played',
        members: "20+",
        members_desc: 'Core Members',
        winrate: "77.5%"
      }
    },
    
    // About Section
    about: {
      subtitle: 'Our Foundation',
      title: 'About Prototype eSports',
      mission: 'Our Mission',
      missionText: 'To dominate the competitive Battlefield scene through strategic excellence, tactical mastery, and unbreakable team coordination. We strive to set the standard for professional esports teams.',
      vision: 'Our Vision',
      visionText: 'To become the most recognized and respected Battlefield esports organization globally, inspiring the next generation of tactical gamers and competitive players.',
      values: 'Core Values',
      byTheNumbers: 'By The Numbers',
      nextGenWarfare: 'Next-Gen Warfare',
      nextGenDesc: 'Experience cutting-edge combat with Battlefield\'s advanced gameplay mechanics',
      communityImpact: 'Community Impact',
      ourJourney: 'Our Journey',
      community: {
        trainingSessions: 'Training Sessions Hosted',
        playersCoached: 'Players Coached',
        communityEvents: 'Community Events',
        discordMembers: 'Discord Members'
      },
      valuesList: [
        { key: 'Strategic Excellence', name: 'Strategic Excellence' },
        { key: 'Team Coordination', name: 'Team Coordination' },
        { key: 'Continuous Improvement', name: 'Continuous Improvement' },
        { key: 'Sportsmanship', name: 'Sportsmanship' },
        { key: 'Community Building', name: 'Community Building' }
      ],
      timeline: {
        2012: {
          title: 'Foundation',
          descriptions: [
            'Prototype eSports established with 5 founding members',
            'First gaming setup acquired',
            'Initial training program developed',
            'BF3 ● 3rd/4th @ ESL Conquest 5on5 Infantry Liga Otoño 2k12 SIL'
          ]
        },
        2020: {
          title: 'First Victory',
          descriptions: [
            'Won our first regional tournament',
            'Expanded team to 10 active players',
            'Established partnership with local sponsors'
          ]
        },
        2022: {
          title: 'Going Pro',
          descriptions: [
            'Entered professional esports scene',
            'Secured major sponsorship deals',
            'Moved to dedicated gaming facility'
          ]
        },
        2024: {
          title: 'Championship',
          descriptions: [
            'Claimed Battlefield Pro League title',
            'Achieved international recognition',
            'Launched youth development program'
          ]
        }
      }
    },
    
    // Contact Section
    contact: {
      subtitle: 'Join The Elite',
      title: 'READY TO ENLIST?',
      description: 'Think you have what it takes to join our elite Battlefield squad? Submit your application and prove your worth on the battlefield.',
      getInTouch: 'Get In Touch',
      followJourney: 'Follow Our Journey: Discord Contact ProType_Base2k',
      form: {
        name: 'Your Name',
        email: 'Email Address',
        message: 'Tell us about your gaming experience',
        send: 'Send Message'
      },
      requirements: {
        title: 'Recruitment Requirements',
        list: [
          'Minimum 500+ hours in Battlefield games',
          'Strong communication and teamwork skills',
          'Available for regular practice sessions',
          'Positive attitude and sportsmanlike conduct',
          'Willingness to learn and improve strategies'
        ]
      },
      proTip: {
        title: 'Pro Tip',
        text: 'Include gameplay videos or match highlights with your application to stand out!'
      }
    },
    
    // Footer
    footer: {
      tagline: 'Competitive Battlefield Players',
      description: 'Dominating the Battlefield esports scene through strategic excellence, tactical mastery, and unbreakable team coordination.',
      quickLinks: 'Quick Links',
      contact: 'Contact',
      discord: 'Discord: ProType_Base2k',
      email: 'Email',
      community: 'Community',
      communityCount: '200+ Discord Members',
      copyright: 'All rights reserved.',
      privacy: 'Privacy Policy',
      terms: 'Terms of Service',
      codeOfConduct: 'Code of Conduct',
      achievement: '15+ Tournament Played • Est. 2012'
    }
  },
  
  es: {
    // Meta Tags
    meta: {
      title: 'Prototype eSports - Guerreros Élite de Battlefield | Gaming Competitivo Desde 2012',
      description: 'Prototype eSports - Guerreros Élite de Battlefield. Dominando los esports competitivos desde 2012 con excelencia estratégica, maestría táctica y trabajo en equipo inquebrantable. ¡Únete a nuestro escuadrón legendario!',
      ogTitle: 'Prototype eSports - Guerreros Élite de Battlefield',
      ogDescription: 'Dominando los esports competitivos de Battlefield desde 2012. 15+ torneos jugados, excelencia estratégica y maestría táctica. ¡Únete a nuestro escuadrón élite!',
      twitterTitle: 'Prototype eSports - Guerreros Élite de Battlefield',
      twitterDescription: 'Dominando los esports competitivos de Battlefield desde 2012. ¡Únete a nuestro escuadrón élite!'
    },
    
    // Navigation
    nav: {
      home: 'Inicio',
      team: 'Equipo',
      tournaments: 'Torneos',
      about: 'Acerca',
      contact: 'Contacto',
      joinSquad: 'Únete al Equipo'
    },
    
    // Hero Section
    hero: {
      title: 'EQUIPO COMPETITIVO BATTLEFIELD',
      subtitle: 'Dominando la escena competitiva de Battlefield con precisión, estrategia y trabajo en equipo inquebrantable.',
      watchHighlights: 'Ver Highlights',
      joinTeam: 'Únete al Equipo'
    },

    clubInfo: {
        name: "Prototype eSports",
        tagline: "Dominating Battlefield",
        description: "Prototype eSports, un club dedicado a la excelencia competitiva y al dominio estratégico. Únete a nuestras filas y vive la emoción de la guerra en equipo.",
        founded: "2012",
        achievements: "15+",
        achievements_desc: "Torneos Jugados",
        members: "20+",
        members_desc: "Miembros Activos",
        winrate: "77,5%",
        winrate_desc: "Avg Win Rate"
    },
    
    // Team Section
    team: {
      subtitle: 'Conoce al Team',
      title: 'EQUIPO PROTOTYPE eSPORTS',
      description: 'Nuestro equipo está formado por veteranos de la saga que han dominado innumerables Battlefields. Cada miembro aporta habilidades únicas y experiencia táctica para asegurar la victoria.',
      stats: {
        battlefield: '6+',
        battlefield_desc: 'Battlefield Compitiendo',
        achievements: "15+",
        achievements_desc: 'Torneos Jugados',
        members: "20+",
        members_desc: 'Miembros Activos',
        winrate: "77.5%"
      }
    },
    
    // About Section
    about: {
      subtitle: 'Nuestra Base',
      title: 'Acerca de Prototype eSports',
      mission: 'Nuestra Misión',
      missionText: 'Dominar la escena competitiva de Battlefield a través de la excelencia estratégica, maestría táctica y coordinación inquebrantable del equipo. Nos esforzamos por establecer el estándar para equipos profesionales de esports.',
      vision: 'Nuestra Visión',
      visionText: 'Convertirnos en la organización de esports de Battlefield más reconocida y respetada a nivel global, inspirando a la próxima generación de gamers tácticos y jugadores competitivos.',
      values: 'Valores Fundamentales',
      byTheNumbers: 'En Números',
      nextGenWarfare: 'Guerra de Nueva Generación',
      nextGenDesc: 'Experimenta combate de vanguardia con las mecánicas avanzadas de Battlefield',
      communityImpact: 'Impacto en la Comunidad',
      ourJourney: 'Nuestro Camino',
      community: {
        trainingSessions: 'Sesiones de Entrenamiento Organizadas',
        playersCoached: 'Jugadores Entrenados',
        communityEvents: 'Eventos Comunitarios',
        discordMembers: 'Miembros de Discord'
      },
      valuesList: [
        { key: 'Strategic Excellence', name: 'Excelencia Estratégica' },
        { key: 'Team Coordination', name: 'Coordinación de Equipo' },
        { key: 'Continuous Improvement', name: 'Mejora Continua' },
        { key: 'Sportsmanship', name: 'Deportividad' },
        { key: 'Community Building', name: 'Construcción de Comunidad' }
      ],
      timeline: {
        2012: {
          title: 'Fundación',
          descriptions: [
            'Prototype eSports establecido con 5 miembros fundadores',
            'Primera configuración de gaming adquirida',
            'Programa inicial de entrenamiento desarrollado',
            'BF3 ● 3º/4º @ ESL Conquest 5on5 Infantry Liga Otoño 2k12 SIL'
          ]
        },
        2020: {
          title: 'Primera Victoria',
          descriptions: [
            'Ganamos nuestro primer torneo regional',
            'Expandimos el equipo a 10 jugadores activos',
            'Establecimos alianza con patrocinadores locales'
          ]
        },
        2022: {
          title: 'Profesionalización',
          descriptions: [
            'Entramos en la escena profesional de esports',
            'Conseguimos acuerdos de patrocinio importantes',
            'Nos mudamos a instalaciones de gaming dedicadas'
          ]
        },
        2024: {
          title: 'Campeonato',
          descriptions: [
            'Reclamamos el título de Battlefield Pro League',
            'Logramos reconocimiento internacional',
            'Lanzamos programa de desarrollo juvenil'
          ]
        }
      }
    },
    
    // Contact Section
    contact: {
      subtitle: 'Únete a la Élite',
      title: '¿LISTO PARA ALISTARTE?',
      description: '¿Crees que tienes lo necesario para unirte a nuestro squad competitivo de Battlefield? Envía tu solicitud y demuestra tu valía en Battlefield',
      getInTouch: 'Contacto',
      followJourney: 'Sigue Nuestras Redes: Contacto Discord ProType_Base2k',
      form: {
        name: 'Tu Nombre',
        email: 'Dirección de Email',
        message: 'Cuéntanos sobre tu experiencia gaming',
        send: 'Enviar Mensaje'
      },
      requirements: {
        title: 'Requisitos de Reclutamiento',
        list: [
          'Mínimo 500+ horas en juegos de Battlefield',
          'Sólidas habilidades de comunicación y trabajo en equipo',
          'Disponibilidad para sesiones regulares de práctica',
          'Actitud positiva y conducta deportiva',
          'Disposición para aprender y mejorar estrategias'
        ]
      },
      proTip: {
        title: 'Consejo Pro',
        text: '¡Incluye videos de gameplay o highlights de partidas con tu solicitud para destacar!'
      }
    },
    
    // Footer
    footer: {
      tagline: 'Jugadores Competitivos de Battlefield',
      description: 'Dominando la escena de esports de Battlefield a través de la excelencia estratégica, maestría táctica y coordinación inquebrantable del equipo.',
      quickLinks: 'Enlaces',
      contact: 'Contacto',
      discord: 'Discord: ProType_Base2k',
      email: 'Email',
      community: 'Comunidad',
      communityCount: '200+ Miembros de Discord',
      copyright: 'Todos los derechos reservados.',
      privacy: 'Política de Privacidad',
      terms: 'Términos de Servicio',
      codeOfConduct: 'Código de Conducta',
      achievement: '15+ Torneos Jugados • Est. 2012'
    }
  }
};